import { always } from 'ramda'
import nil from './nil'

let noop = always(nil)

export default noop
